<template>
  <v-expansion-panel class="pt-2">
    <v-expansion-panel-header class="expansion--panel">
      <template>
        <v-row no-gutters>
          <v-col cols="4"><v-icon color="white">mdi-currency-eur</v-icon> {{ $t("message.product.priceHistory") }}</v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pt-2">
      <data-list :payload="modelObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
      </data-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import DataList from '../../components/DataList.vue'
import { mapState } from 'vuex'
export default {
  components: {
    DataList
  },
  props: {
    model: {
      type: Object
    }
  },
  data () {
    return {
      modelObj: {
        isHeader: true,
        isHideAdd: false,
        hasFilters: true,
        selection: [],
        list: [],
        loading: true,
        page: 1
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.PRICE_HISTORY_INDEX) ? this.$store.state.PRICE_HISTORY_INDEX : { sortBy: ['supplierprice'], itemsPerPage: 25, sortDesc: [true], search: '' },
      filterObj: {
        search: '',
        productid: this.model.id
      },
      search: ''
    }
  },
  created () {
    this.getListHandler()
  },
  computed: {
    ...mapState(['PRICE_HISTORY_INDEX']),
    headers () {
      return [{
        text: this.$t('message.product.supplierPrice'),
        value: 'supplierprice',
        width: '15%'
      }, {
        text: `${this.$t('message.product.realCostNOK')}`,
        value: 'realcostnok',
        width: '15%'
      }, {
        text: `${this.$t('message.product.salesPrice')}`,
        value: 'saleprice',
        width: '15%'
      }, {
        text: `${this.$t('message.currency.validFrom')}`,
        value: 'pricevalidfrom',
        width: '15%'
      }, {
        text: `${this.$t('message.product.wayOfUpdate')}`,
        value: 'wayofupdate',
        width: '15%'
      }]
    }
  },
  watch: {
    pagination (val) {
      let model = { type: 'PRICE_HISTORY_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    }
  },
  methods: {
    getListHandler () {
      this.modelObj.loading = true
      let query = {
        'filter': `productid eq ${this.model.id}`
      }
      this.$_executeApi('post', `productpricehistories/query`, query)
        .then(async (response) => {
          let data = response.data
          let transformData = { number: { list: ['supplierprice', 'realcostnok', 'saleprice'], format: 'replaceDotWithComma' },
            date: { list: ['pricevalidfrom'], from: 'DD-MM-YYYY', to: 'DD.MM.YYYY' } }
          let model = this.$_formatListModel(data, transformData)
          model.map(x => {
            try {
              x.wayofupdate = this.$t(`message.product.${x.wayofupdate}`)
            } catch (err) {} // do handle it in future
            return x
          })
          this.modelObj.list = model
          this.modelObj.loading = false
        })
    }
  }
}
</script>
